import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { Box } from '@chakra-ui/react';
import {
  Wrapper,
  NavigationButton,
  PostDetails,
  BoldText,
  NoramlText,
} from './PostNavigationStyled';
import { IPostNavigationProps } from './interfaces';
import { usePostContext } from '@components/Post/PostContext';
import NextChakraLink from '@components/Shared/NextChakraLink';

const PostNavigation: React.FC<IPostNavigationProps> = () => {
  const { postNavigation } = usePostContext();
  return (
    <Wrapper>
      <NavigationButton>
        {postNavigation?.prevPost && (
          <NextChakraLink
            href={`/blog/${postNavigation.prevPost.slug}`}
            display="flex"
            justifyContent="center"
            alignItems="flex-start"
            _hover={{ color: 'pink.50' }}
          >
            <Box mt="10px">
              <FontAwesomeIcon icon={faChevronLeft} />
            </Box>
            <PostDetails direction="left">
              <BoldText>Previous Post</BoldText>
              <NoramlText>{postNavigation.prevPost.title}</NoramlText>
            </PostDetails>
          </NextChakraLink>
        )}
      </NavigationButton>
      <NavigationButton>
        {postNavigation.nextPost && (
          <NextChakraLink
            href={`/blog/${postNavigation.nextPost.slug}`}
            display="flex"
            justifyContent="center"
            alignItems="flex-start"
          >
            <PostDetails direction="right">
              <BoldText>Next Post</BoldText>
              <NoramlText>{postNavigation.nextPost.title}</NoramlText>
            </PostDetails>
            <Box mt="10px">
              <FontAwesomeIcon icon={faChevronRight} />
            </Box>
          </NextChakraLink>
        )}
      </NavigationButton>
    </Wrapper>
  );
};

export default PostNavigation;
